// ponytail: example Sentry issues, shown while Sentry isn't connected so the card keeps its shape, and the Sentry
// events sparkline until it has a real source. AWS data is real (services/systemHealth.ts).

export interface SentryIssue {
    shortId: string;
    title: string;
    project: string;
    level: 'error' | 'warning' | 'fatal';
    count: number;
    users: number;
    lastSeen: Date;
    permalink?: string;
}

const minutesAgo = (m: number) => new Date(Date.now() - m * 60_000);

export const sentryIssues: SentryIssue[] = [
    {
        shortId: 'CORE-API-4F2',
        title: 'SqlException: Timeout expired. The timeout period elapsed prior to completion',
        project: 'bygr-core-api',
        level: 'error',
        count: 412,
        users: 38,
        lastSeen: minutesAgo(1),
    },
    {
        shortId: 'CM-WEB-19A',
        title: "TypeError: Cannot read properties of undefined (reading 'units')",
        project: 'cm-frontend',
        level: 'error',
        count: 156,
        users: 22,
        lastSeen: minutesAgo(4),
    },
    {
        shortId: 'BACKEND-88C',
        title: 'NullReferenceException in ChangeRequestService.GetSummary',
        project: 'bygr-backend',
        level: 'error',
        count: 61,
        users: 9,
        lastSeen: minutesAgo(17),
    },
    {
        shortId: 'AMQM-2D1',
        title: 'HttpRequestException: Connection refused (core-api:80)',
        project: 'bygr-backend-am-qm',
        level: 'warning',
        count: 44,
        users: 0,
        lastSeen: minutesAgo(12),
    },
    {
        shortId: 'RUBEN-7B0',
        title: 'Pinecone query exceeded 10s deadline',
        project: 'ruben-backend',
        level: 'warning',
        count: 12,
        users: 5,
        lastSeen: minutesAgo(52),
    },
];

// Last 30 minutes, one point per minute, for the Sentry stat tile.
export const sentryEventsHistory = Array.from({ length: 30 }, () => 55 + (Math.random() - 0.5) * 30);
